import PropTypes from 'prop-types'

const CustomerCheckoutSection = ({
  header,
  isEditButtonVisible = true,
  handleClickEdit,
  children
}) => (
  <div className='mb-4'>
    <div className='d-flex justify-content-between text-gray-light mb-1'>
      <strong>{ header }</strong>
      {
        isEditButtonVisible
          ? (
            <i
              className='fas fa-pencil-alt'
              onClick={ () => handleClickEdit() }
            />
          )
          : null
      }
    </div>

    { children }
  </div>
)

CustomerCheckoutSection.propTypes = {
  header              : PropTypes.string,
  isEditButtonVisible : PropTypes.bool,
  handleClickEdit     : PropTypes.func,
  children            : PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
}

CustomerCheckoutSection.defaultProps = {
  header              : 'Default Header',
  isEditButtonVisible : true,
  handleClickEdit     : () => { },
  children            : null
}

export default CustomerCheckoutSection
